import { ViewDepot } from "./components/ViewDepot";

export default ViewDepot;